/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacySummaryDataLastActivityActorTypeSchema = z.enum(['recruiter', 'candidate', 'system'])

export type CandidacySummaryDataLastActivityActorTypeSchema = z.infer<
	typeof candidacySummaryDataLastActivityActorTypeSchema
>
